import { WDHGeoIpPrompt } from '../../../../wdh-feature/wdh-geo-ip-prompt';
var geoIpPrompt = new WDHGeoIpPrompt();
geoIpPrompt.zIndex = 1001;
geoIpPrompt.run();